import React from 'react';
import PropTypes from 'prop-types';

import { Grid, makeStyles } from '@material-ui/core';

const propTypes = {
    children: PropTypes.node,
    icon: PropTypes.node,
    error: PropTypes.bool
};

const defaultProps = {
    children: null,
    icon: null,
    error: false
};

const useStyles = makeStyles((theme) => styles(theme));

function AuthBodyTextFieldRow ({ icon, error, children }) {
    const classes = useStyles();
    return (
        <Grid 
            classes={{ root: classes.root }}
            container
            spacing={1}
            alignItems={error ? 'center' : 'flex-end'}
        >
            <Grid item xs={1}>
                {icon}
            </Grid>
            <Grid item xs={11}>
                {children}
            </Grid>
        </Grid>
    );
}

const styles = (theme) => ({
    root: {
        marginTop: 12
    },
});

AuthBodyTextFieldRow.propTypes = propTypes;
AuthBodyTextFieldRow.defaultProps = defaultProps;

export default AuthBodyTextFieldRow;